<template>
  <section id="education-form">
    <div class="columns">
      <div class="column is-half">
        <div class="field is-grouped">
          <div class="control" style="width: 65%;">
            <label class="label">โรงเรียน</label>
            <input class="input" type="text" placeholder="ชื่อของโรงเรียน" v-model="formData.school">
          </div>
          <div class="control" style="width: 33%;">
            <label class="label">จังหวัด</label>
            <input class="input" type="text" placeholder="จังหวัดของโรงเรียน" v-model="formData.schoolProvince">
          </div>
        </div>
        <div class="field is-grouped">
          <div class="control">
            <label class="label">ระดับการศึกษา</label>
            <div class="select">
              <select v-model="formData.currentStudyYear">
                <option>ม.4 (ขึ้น ม.5 หรือเทียบเท่า)</option>
                <option>ม.5 (ขึ้น ม.6 หรือเทียบเท่า)</option>
                <option>ม.6 (ขึ้น ปี 1 หรือเทียบเท่า)</option>
              </select>
            </div>
          </div>
          <div class="control">
            <label class="label">แผนการเรียน</label>
            <div class="select">
              <select v-model="formData.major">
                <option>วิทย์/คณิต</option>
                <option>ศิลป์/ภาษา</option>
                <option>ศิลป์/คำนวน</option>
                <option>สายอาชีพอื่น ๆ</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <div class="control">
            <label class="label">เกรดเฉลี่ย</label>
            <input class="input" type="number" placeholder="เกรดเฉลี่ย" v-model="formData.gpa">
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
    export default {
        name: "EducationForm",
        data: function () {
            return {
                formData: {}
            }
        },
        methods: {},
        watch: {
            userFormDataState(newFormState) {
                this.formData = newFormState;
            },
            async formValue() {
                await this.$store.dispatch('setUserFormData', this.formData)
            }
        },
        computed: {
            formValue() {
                return Object.values(this.formData);
            },
            userFormDataState() {
                return this.$store.getters.userFormData;
            }
        }
    }
</script>

<style scoped>

</style>
